import { AxiosError } from 'axios';
import instance from '../config/axios';

export async function validatePostMarkTemplate(
  token: string,
  alias: string,
  type: string,
) {
  try {
    const response = await instance({
      method: 'GET',
      url: `/api/v1/validate/template/${alias}/${type}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data.message;
  } catch (e) {
    console.log((e as AxiosError).response!.status);
    return (e as AxiosError).response!.status;
  }
}
